import { Box, Container } from "@mui/material";
import React from "react";
import WorldMap from "src/Component/CountryComponent/WorldMap";
import Header from "src/Component/content-component/Header";

const StudyAbroadCountry = () => {
  return (
    <>
      {" "}
      <Box sx={{ backgroundColor: "#ffffff", padding: "0px 30px" }}>
        <Container>
          <Box id='countries-section' sx={{ display: "flex", justifyContent: "center", mb: "20px" }}>
            <Header
              color="#00999e"
              textAlign="center"
              content="Pick Your Destination"
            />
          </Box>
          <Box
            sx={{
              backgroundColor: "#ffffff",
              padding: "10px",
              margin: "10px",
              border: "2px solid #00999E",
              borderRadius: "10px",
              boxShadow: "2px 2px 2px rgba(0,0,0,0.4)"
            }}
          >
            <WorldMap />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default StudyAbroadCountry;
